import React, { useState } from "react";
import { TablePagination } from "@mui/material";

const rowsPerPageOptions = [5, 10, 50] as const;
type PaginationProps = {
  limit: typeof rowsPerPageOptions[number];
  totalCount: number;
  containerClass?: string;
  getUpdatedRecords: (limit: number, page: number) => void;
}
export default function CommonPagination(props: PaginationProps) {
  const { limit: defaultLimit, containerClass = '', totalCount, getUpdatedRecords } = props;
  const [limit, setLimit] = useState(defaultLimit);
  const [currentPage, setCurrentPage] = useState(0);
  
  function handleChangePage(e: any, page: number) {
    setCurrentPage(page);
    getUpdatedRecords(limit, page + 1);
  }
  function handleChangeRowsPerPage(e: any) {
    setCurrentPage(0);
    setLimit(e.target.value);
    getUpdatedRecords(e.target.value, 1);
  }

  return <div className={`flex items-center ${containerClass}`}>
    <TablePagination
      component="div"
      rowsPerPageOptions={[...rowsPerPageOptions]}
      count={totalCount}
      page={currentPage}
      onPageChange={handleChangePage}
      rowsPerPage={limit}
      onRowsPerPageChange={handleChangeRowsPerPage}
    />
  </div>
}